import { PiArrowLeft } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { Button } from "rizzui";

export default function BackButton() {
  const navigate = useNavigate();
  return (
    <Button
      size="sm"
      variant="outline"
      onClick={() => navigate(-1)}
      className="flex items-center gap-2"
    >
      <PiArrowLeft />
      Back
    </Button>
  );
}
